import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Role } from '../../organization/models/organization-role'
import type { InvitationState } from '../../organization/models/invitation-state'
import type { Member } from '../../../core/models/member/member'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'

export const useOrganization = () => {
  const { data, load, status, reload } = useGet<ManageableOrganization>('organization')
  onMounted(() => {
    load()
  })

  const createMemberBus = useEventBus(EventKey.organizationMemberCreated)
  createMemberBus.on(() => reload())

  return { data, status, reload }
}

export interface ManageableOrganization {
  id: string
  name: string
  members: ManageableMember[]
  availableRoles: Role[]
}

export type ManageableMember = Member & {
  invitationState: InvitationState | null
  roles: ReadonlyArray<Role>
  teams: ReadonlyArray<{ id: string; name: string }>
}
